const CategoryProduct = {
  id: 'CategoryProduct',
  type: 'object',
  required: [
    'categoryProductName',
    'coverCategoryProduct',
    'detailCategoryProduct'
  ],
  properties: {
    type: {
      type: ['string', 'null']
    },
    mainCategoryProduct: {
      type: ['string']
    },
    categoryProductName: {
      type: 'string',
      minLength: 3,
      maxLength: 150
    },
    coverCategoryProduct: {
      type: 'string'
    },
    // imageCategoryProduct: {
    //   type: 'string'
    // },
    detailCategoryProduct: {
      type: 'string',
      minLength: 3
    }
  }
};

export default CategoryProduct;
